export default "__VITE_ASSET__d68c0aed__"